const setSlides = (state, payload) => {
  state.slides = payload
}

export default {
  setSlides,
}
